/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {
   upperLimitNoIsNull: { SC: "上限不能为空", TC: "上限不能為空", EN: "Upper Limit is required." }
   , download: { SC: "下载中...", TC: "下載中...", EN: "Downloading..." }
   , codeNoIsNull: { SC: "编码不能为空", TC: "編碼不能為空", EN: "Code is required." }
   , descriptionNoIsNull: { SC: "描述不能为空", TC: "描述不能為空", EN: "Description is required." }
   , activeIndNoIsNull: { SC: "是否激活不能为空", TC: "是否激活不能為空", EN: "Active is required." }
   , noIsNull: { SC: "不能为空", TC: "不能為空", EN: " is required." }
   , selectiveData: { SC: "请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
   , pleaseSelectAtLeastOneRecord: { SC: "请选择至少一条数据", TC: "請選擇至少一條數據", EN: "Please select at least one record." }
   , deleteData: { SC: "数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
   , deleteSuccess: { SC: "删除成功", TC: "刪除成功", EN: "Deleted successfully." }
   , beQuerying: { SC: "查询中...", TC: "査詢中...", EN: "Searching..." }
   , noneDate: { SC: "找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
   , saveSuccess: { SC: "保存成功", TC: "保存成功", EN: "Saved successfully." }
   , controls: { SC: "操作", TC: "操作", EN: "Operation" }
   , add: { SC: "Add", TC: "Add", EN: "Add" }
   , dataBeSaving: { SC: "数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
   , withdrawnSuccess: { SC: "Withdrew successfully.", TC: "Withdrew successfully.", EN: "Withdrew successfully." }
   , approvalSuccess: { SC: "Approved successfully.", TC: "Approved successfully.", EN: "Approved successfully." }
   , rejectSuccess: { SC: "Rejected successfully.", TC: "Rejected successfully.", EN: "Rejected successfully." }

   , save: { SC: "Save", TC: "Save", EN: "Save" }
   , select: { SC: "Select", TC: "Select", EN: "Select" }
   , cancel: { SC: "Cancel", TC: "Cancel", EN: "Cancel" }
   , view: { SC: "View", TC: "View", EN: "View" }
   , delete: { SC: "Delete", TC: "Delete", EN: "Delete" }
   , audit: { SC: "Log", TC: "Log", EN: "Log" }
   , list: { SC: "List", TC: "List", EN: "List" }
   , search: { SC: "Search", TC: "Search", EN: "Search" }
   , reset: { SC: "Reset", TC: "Reset", EN: "Reset" }
   , update: { EN: "Edit" }
   , approve: { EN: "Approve" }
   , reject: { EN: "Reject" }
   , withdrawn: { EN: "Withdrawn" }
   , batchUpload: { EN: "Batch Upload" }
   , saveUpload: { EN: "Save & Upload" }
   , saveAsDraft: { EN: "Save as Draft" }
   , submit: { EN: "Submit" }
   , jobManagement: { EN: "Job Posting Record" }
   , studentID: { EN: "Student ID" }
   , studentName: { EN: "Student Name" }
   , email: { EN: "Email" }
   , prog: { EN: "Programme" }

   , jobId: { EN: "Job Post ID" }
   , jobTitle: { EN: "Job Title" }
   , vacancies: { EN: "Job Vacancies" }
   , positionType: { EN: "Job Mode" }
   , jobType: { EN: "Employment Type" }
   , industrialPartner: { EN: "Company Name" }
   , programme: { EN: "Programme Code" }
   , programmeTitle: { EN: "Programme Name" }
   , jobDesc: { EN: "Job Description" }
   , jobRequirement: { EN: "Job Requirement" }
   , salary: { EN: "Salary (HKD)" }
   , unit: { EN: "Salary Basis" }
   , workLocation: { EN: "Work Location" }
   , lastApplyDate: { EN: "Last Day of Application" }
   , jobPostSubmitDate: { EN: "Job Post Submit Date" }
   , jobPostStatus: { EN: "Job Post Status" }
   , programmeReviewStatus: { EN: "Programme Review Status" }
   , programmeReviewDate: { EN: "Programme Review Date" }
   , approveInfo: { EN: "Approve / Reject" }
   , approveStatus: { EN: "Status" }
   , remarks: { EN: "Remarks" }
   , fullPartTime: { EN : "Full/Part Time" }
   , applyMethod: { EN: "Job Application Method" }
   , description: { EN: "Description" }
   , otherDesc: { EN: "Other Description" }
   , estimatedNoOfDaysAWeek: { EN: "Estimated no. of days a week" }
   , estimatedNoOfHoursAWeek: { EN: "Estimated no. of hours a week" }
   , expectDate: { EN: "Expected Date" }
   , startDate: { EN: "Expected Commence Date" }
   , endDate: { EN: "Expected End Date" }
   , assignedStudents: { EN: "Assigned Students" }
   , rejectReason: { EN: "Reject Reason" }
   
   , workLocationIsNoNull: { EN: "Work Location is required." }
   , applyMethodIsNoNull: { EN: "Job Application Method is required." }
   , jobPostStatusIsNoNull: { EN: "Job Post Status is required." }
   , rangeFromIsNoNull: { EN: "Range From is required." }
   , rangeToIsNoNull: { EN: "Range To is required." }
   , programmeIsNoNull: { EN: "Programme Code is required." }
   , companyNameIsNoNull: { EN: "Company Name is required." }
   , vacanciesIsNoNull: { EN: "Job Vacancies is required." }
   , jobTitleIsNoNull: { EN: "Job Title is required." }
   , approveStatusIsNoNull: { EN: "Status is required." }
   , unitIsNoNull: { EN: "Salary Basis is required." }
   , eventRemarkIsNoNull: { EN: "Remarks is required." }
   , positionTypeIsNoNull: { EN: "Job Mode is required." }
   , jobTypeIsNoNull: { EN: "Employment Type is required." }

   , greaterThan: { SC:"Salary cannot be greater than ", TC: "Salary cannot be greater than ", EN: "Salary cannot be greater than " }
   , lessThan: { SC:"Salary should be greater than ", TC: "Salary should be greater than " , EN: "Salary should be greater than " }
   , greaterThan0: { SC:"Salary greater or equal than 0.", TC: "Salary greater or equal than 0.", EN: "Salary greater or equal than 0." }
}